import React from 'react'

import { Box, ThemeProvider, Typography } from '@material-ui/core'
import { isEmpty } from 'lodash'

import defaultTheme from 'theme'
import GuestJourneyProvider from 'providers/GuestJourneyProvider'
import PortalLoadingScreen from 'views/Guests/components/PortalLoadingScreen'
import useAuthGuest from 'hooks/useAuthGuest'
import useCustomTheme from 'hooks/useCustomTheme'
import useGuestJourney from 'hooks/useGuestJourney'
import logoDponetWhite from 'images/dponet-logo-white.svg'
import useStyles from './styles'

const PORTAL_DESCRIPTIONS = {
  privacy_by_design: 'para acompanhar projetos e análises de privacidade.',
  ai_inventory: 'para acompanhar o inventário de ferramentas de IA.',
}

const PORTAL_NAMES = {
  privacy_by_design: 'Privacy by Design',
  ai_inventory: 'Inventário de IA',
}

// Índices das etapas do fluxo de convidado do Inventário de IA.
const EMAIL_STEP_INDEX = 0
const TWO_FACTOR_STEP_INDEX = 1
const REGISTRATION_METHOD_STEP_INDEX = 3

const LeftPanel = () => {
  const classes = useStyles()
  const { activeStep, companyInfo, guestModule } = useGuestJourney()
  const { customLogo } = useCustomTheme()

  const portalName = PORTAL_NAMES[guestModule] || 'Privacy by Design'
  const portalDescription =
    PORTAL_DESCRIPTIONS[guestModule] ||
    'para acompanhar projetos e análises de privacidade.'

  const isAiInventory = guestModule === 'ai_inventory'
  const isAiInventoryEmailStep =
    isAiInventory && activeStep === EMAIL_STEP_INDEX
  const isAiInventoryTwoFactorStep =
    isAiInventory && activeStep === TWO_FACTOR_STEP_INDEX
  const isAiInventoryRegistrationStep =
    isAiInventory && activeStep === REGISTRATION_METHOD_STEP_INDEX

  return (
    <Box className={classes.leftBox}>
      <Box className={classes.leftContent}>
        {customLogo && (
          <img
            src={customLogo}
            alt={companyInfo?.name || 'Logo'}
            className={classes.logo}
          />
        )}
        {companyInfo?.name &&
          (isAiInventoryEmailStep ? (
            <Typography variant="body1" className={classes.welcomeText}>
              Você recebeu este link porque <strong>{companyInfo.name}</strong>{' '}
              está mapeando as ferramentas de inteligência artificial
              utilizadas. Neste portal, você responderá a um formulário rápido
              indicando quais ferramentas de IA usa nas suas atividades e como
              as utiliza. O levantamento é uma iniciativa oficial da organização
              e é essencial para garantir o uso seguro e adequado dessas
              tecnologias.
            </Typography>
          ) : isAiInventoryTwoFactorStep ? (
            <Typography variant="body1" className={classes.welcomeText}>
              Etapa de verificação de segurança. Confirme o código enviado ao
              seu e-mail para acessar o formulário de Inventário de IA.
            </Typography>
          ) : isAiInventoryRegistrationStep ? (
            <Typography variant="body1" className={classes.welcomeText}>
              Registre as ferramentas de IA que você utiliza no trabalho. Se
              tiver dúvidas sobre o que informar, o cadastro guiado te acompanha
              em cada etapa.
            </Typography>
          ) : (
            <Typography variant="body1" className={classes.welcomeText}>
              Acesse o portal de {portalName} de{' '}
              <strong>{companyInfo.name}</strong> {portalDescription}
            </Typography>
          ))}
      </Box>
    </Box>
  )
}

const GuestsJourneyLayout = ({ guestModule, redirectPath, children }) => {
  const { customTheme } = useCustomTheme()
  const { loaded } = useAuthGuest()
  const activeTheme = isEmpty(customTheme) ? defaultTheme : customTheme

  if (!loaded) return <PortalLoadingScreen />

  return (
    <ThemeProvider theme={activeTheme}>
      <GuestJourneyProvider
        guestModule={guestModule}
        redirectPath={redirectPath}
      >
        <Layout>{children}</Layout>
      </GuestJourneyProvider>
    </ThemeProvider>
  )
}

const Layout = ({ children }) => {
  const classes = useStyles()

  return (
    <Box className={classes.root}>
      <LeftPanel />
      <Box className={classes.wrapper}>{children}</Box>
    </Box>
  )
}

export default GuestsJourneyLayout
